<template>
  <div v-loading="loading" class="meetings">
    <div class="filters-before-table" style="display: flex; gap: 30px">
      <el-radio-group v-model="filters.mode" size="small" @change="filtersChanged">
        <el-radio-button
          v-for="opt in $oneToOneConstants.meetings.modeSelectOptions"
          :key="opt.id"
          :label="opt.id"
        >{{ opt.name }}</el-radio-button>
      </el-radio-group>

      <el-select
        v-model="filters.status"
        clearable
        placeholder="Статус"
        size="small"
        multiple
        style="width: 180px"
        @change="filtersChanged"
      >
        <el-option
          v-for="opt in $oneToOneConstants.meetings.statusesSelectOptions"
          :key="opt.id"
          :label="opt.name"
          :value="opt.id"
        />
      </el-select>

      <el-select
        v-model="filters.type"
        clearable
        placeholder="Тип встречи"
        multiple
        size="small"
        style="width: 180px"
        @change="filtersChanged"
      >
        <el-option
          v-for="opt in $oneToOneConstants.meetings.typeSelectOptions"
          :key="opt.id"
          :label="opt.name"
          :value="opt.id"
        />
      </el-select>


      <el-date-picker
        v-model="filters.dateRange"
        type="daterange"
        range-separator="—"
        start-placeholder="Дата с"
        end-placeholder="Дата по"
        format="dd.MM.yyyy"
        value-format="yyyy-MM-dd"
        size="small"
        style="width: 240px"
        @change="onDateRangeChange"
      />
    </div>

    <div class="meetings-block">
      <el-table
        :data="meetings"
        :show-header="!!meetings.length"
        empty-text="Нет созданных встреч"
        :row-key="(row) => row.id"
        @sort-change="sortChanged($event, loadMeetings)"
        @row-click="onRowClick"
      >
        <el-table-column label="Дата" width="120" v-slot="scope" prop="date" sortable="custom">
          {{(new Date(scope.row.date)).toLocaleDateString($companyConfiguration.helpers.getDateLocale()) }}
        </el-table-column>
        <el-table-column label="Время" width="100" prop="time" sortable="custom" v-slot="scope">
          {{ scope.row.time ? scope.row.time.slice(0,5) : '' }}
        </el-table-column>
        <el-table-column label="Тип" width="150" prop="type" sortable="custom" v-slot="scope">
          {{ $oneToOneConstants.meetings.typeSelectOptions.find(e=>e.id===scope.row.type).name || scope.row.type }}
        </el-table-column>
        <el-table-column label="Инициатор" v-slot="scope">
          {{ scope.row.initiator ? scope.row.initiator.full_name : '—' }}
        </el-table-column>
        <el-table-column label="Участник" min-width="180" prop="participant.full_name" sortable="custom" v-slot="scope">
          {{ scope.row.participant ? scope.row.participant.full_name : '—' }}
        </el-table-column>
        <el-table-column label="Длительность" width="150" prop="duration" sortable="custom" v-slot="scope">
          {{ scope.row.planned_duration ? scope.row.planned_duration + ' мин.' : '—' }}
        </el-table-column>
        <el-table-column label="Формат" width="100" prop="format" sortable="custom" v-slot="scope">
          {{ $oneToOneConstants.meetings.formatSelectOptions.find(e=>e.id===scope.row.format).name || '—' }}
        </el-table-column>
        <el-table-column label="Статус" width="160" prop="status" sortable="custom" v-slot="scope">
          <el-tag
            size="small"
            :type="$oneToOneConstants.meetings.statusTypes[scope.row.status]"
          >
            {{ $oneToOneConstants.meetings.statusesSelectOptions.find(e => e.id===scope.row.status).name || scope.row.status }}
          </el-tag>
        </el-table-column>
        <el-table-column width="80" align="right" v-slot="scope">
          <el-popconfirm
            confirm-button-text="Да"
            cancel-button-text="Нет"
            icon="el-icon-question"
            title="Отменить встречу?"
            @confirm="cancelMeeting(scope.row)"
          >
            <el-button
              v-if="scope.row.status === $oneToOneConstants.meetings.statuses.STATUS_PLANNED"
              slot="reference"
              class="table-action-button"
              size="mini"
              round
              icon="fas fa-ban"
              @click.stop
            />
          </el-popconfirm>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadMeetings"
    ></paginator>
  </div>
</template>

<script>
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";
import Paginator from "@/components/Paginator.vue";
import {paginator} from "@/mixins/paginator";
import {sorter} from "@/mixins/sorter";

export default {
  name: 'MeetingsList',
  components: {Paginator},
  mixins: [paginator, sorter],
  computed: {
    $oneToOneConstants() {
      return $oneToOneConstants
    }
  },

  data() {
    return {
      loading: false,
      meetings: [],
      filters: {
        mode:      '',
        status:    null,
        type:      null,
        dateRange: null,
        date_from: null,
        date_to:   null,
      },
    };
  },

  mounted() {
    this.loadMeetings();
  },

  methods: {
    loadMeetings() {
      this.loading = true;
      this.$api.oneToOne.meetingSearch({
        ...this.filters,
        expand: [
          'participant',
          'initiator',
        ].join(),

        [this.sorter.param]: this.sorter.sort,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator, sorter}) => {
          this.meetings = data.meetings;
          this.paginatorFill(paginator);
          this.sorterFill(sorter);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    filtersChanged() {
      this.loadMeetings();
    },

    onDateRangeChange(range) {
      this.filters.date_from = range ? range[0] : null;
      this.filters.date_to   = range ? range[1] : null;
      this.loadMeetings();
    },

    onRowClick(row) {
      this.$router.push({ name: 'OneToOneMeeting', params: { id: row.id } });
    },

    cancelMeeting(meeting) {
      this.$api.oneToOne.meetingCancel({ id: meeting.id })
        .then(() => {
          this.loadMeetings();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.meetings {
  .meetings-block {
    margin: 25px 0;
  }

  .table-router-link {
    text-decoration: none;
  }
}
</style>